import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a7637d462b826c5fc88bf013cf0eff440b from "./generated-9bc4ab59-3ea4-42fc-9ec0-f5716b3d4d89.json";

import a17cdd498b17865cd685657dcddc2067cb from "./generated-0e50218e-7636-4a65-98c6-bb92511589ca.json";

import ad65c3867bb4365c2e712673ef50fe1f6b from "./generated-e1c2511b-bde2-4ed0-8b40-e74686c6e15e.json";

import aba019ee54b8563d8cb6bafe4c19023a7b from "./generated-b336c1d5-c42a-422e-ac83-759e07878bf8.json";

import aebe0c6b7afbf6e63336f58804be7bc13b from "./generated-a5c5230b-18c7-46ee-9acc-cd47198ad498.json";

import aebf794ade3c3e46c840cee4d067a3592b from "./generated-3782773c-4fc9-49f4-aeac-da274574b298.json";

import a391de0346e3ef4d97cfe4f90e884e71ab from "./generated-f3b81a64-0a34-46bf-bdf0-8b0b59b17197.json";

import a7bed34b989f9259fc4ef0c75dd62ca8cb from "./generated-91da4dbe-5f6f-44e1-95e9-0846cf2e52b4.json";

import a1b5ef4b3018e70f3b71db8d1970fe0fdb from "./generated-eb50b93a-bcdb-4dc0-a779-ff5faeba3c75.json";

import a3c0617234b49df2b4720721b5c1bbe1eb from "./generated-6c0b5a0b-aca6-48bc-af10-9a0c9b4f0747.json";

import a32b7641b05c7508947c7bff222e54838b from "./generated-6fbda4e7-d91f-4c40-8b00-43df7b894463.json";

import a2c2c2c8c92a56b598d7cf870b08a902ab from "./generated-b2164162-b016-433c-b9d8-9dc0fdafefa8.json";

import a7bf6271c0701862c4193fb7f31055efcb from "./generated-de0ac40c-3eb4-4da1-9252-18cbf8b97b0f.json";

import a4eaf602ef3ab199e472b0dc77020197cb from "./generated-e58c951e-f838-4fbe-8591-71b844c26455.json";

import ae353bf6301f21518955b8f5cd8c29853b from "./generated-1159b36a-4fe4-42c3-9f0d-4c692fa90f8c.json";

import afd7a9e37f230e38e7242716ce382b71cb from "./generated-8fff3ed1-982c-4832-af4a-24ab1031aea5.json";

import ace88d89815b7b1a7fcc65ec82daa4348b from "./generated-e6578a0e-4684-417b-8cbe-f95bfbe19074.json";

import a74315aa1857b6e5527cffea8fccd7f69b from "./generated-91c001c8-e946-4821-98e1-532eb953cad5.json";

import a8e6c1cbe2142a6b42e3902fd5bd4edc8b from "./generated-b4598591-c920-4dae-858d-5d9c932e4cd6.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a7637d462b826c5fc88bf013cf0eff440b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a17cdd498b17865cd685657dcddc2067cb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ad65c3867bb4365c2e712673ef50fe1f6b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aba019ee54b8563d8cb6bafe4c19023a7b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aebe0c6b7afbf6e63336f58804be7bc13b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(aebf794ade3c3e46c840cee4d067a3592b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a391de0346e3ef4d97cfe4f90e884e71ab);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a7bed34b989f9259fc4ef0c75dd62ca8cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a1b5ef4b3018e70f3b71db8d1970fe0fdb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a3c0617234b49df2b4720721b5c1bbe1eb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a32b7641b05c7508947c7bff222e54838b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a2c2c2c8c92a56b598d7cf870b08a902ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a7bf6271c0701862c4193fb7f31055efcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a4eaf602ef3ab199e472b0dc77020197cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ae353bf6301f21518955b8f5cd8c29853b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(afd7a9e37f230e38e7242716ce382b71cb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ace88d89815b7b1a7fcc65ec82daa4348b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a74315aa1857b6e5527cffea8fccd7f69b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a8e6c1cbe2142a6b42e3902fd5bd4edc8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ace88d89815b7b1a7fcc65ec82daa4348b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */